import {createReducer, on, State} from '@ngrx/store';
import {
  loadBuildKitNames,
  loadBuildKitNamesFailure,
  loadBuildKitNamesSuccess,
  loadCadModelNames,
  loadCadModelNamesFailure,
  loadCadModelNamesSuccess,
  loadCotsTypeNames,
  loadCotsTypeNamesFailure,
  loadCotsTypeNamesSuccess,
  loadMaterialNames,
  loadMaterialNamesFailure,
  loadMaterialNamesSuccess,
  loadMaterialFamilyNames,
  loadMaterialFamilyNamesFailure,
  loadMaterialFamilyNamesSuccess,
  loadOrganizationNames,
  loadOrganizationNamesFailure,
  loadOrganizationNamesSuccess,
  loadProjectNames,
  loadProjectNamesFailure,
  loadProjectNamesSuccess,
  loadShapeTypeNames,
  loadShapeTypeNamesFailure,
  loadShapeTypeNamesSuccess,
  NamesAndIds


} from "./dropdown-data.action";
import {StateStatus} from "../../../shared/models/state-status.models";
import {v4 as uuidv4} from 'uuid';

export interface DropdownDataState {
  materialFamilyNames: NamesAndIds[];
  materialFamilyStatus: StateStatus;

  materialNames: NamesAndIds[];
  materialNameStatus: StateStatus;

  organizationNames: NamesAndIds[];
  organizationNameStatus: StateStatus;

  shapeTypeNames: NamesAndIds[];
  shapeTypeNameStatus: StateStatus;

  cotsTypeNames: NamesAndIds[];
  cotsTypeNameStatus: StateStatus;

  projectNames: NamesAndIds[];
  projectNameStatus: StateStatus;

  buildKitNames: NamesAndIds[];
  buildKitNameStatus: StateStatus;

  cadModelNames: NamesAndIds[];
  cadModelNameStatus: StateStatus;
  error: string | null;
}

export const initialState: DropdownDataState = {
  materialFamilyNames: [],
  materialFamilyStatus: 'pending' as StateStatus,
  materialNames: [],
  materialNameStatus: 'pending' as StateStatus,
  organizationNames: [],
  organizationNameStatus: 'pending' as StateStatus,
  shapeTypeNames: [],
  shapeTypeNameStatus: 'pending' as StateStatus,
  cotsTypeNames: [],
  cotsTypeNameStatus: 'pending' as StateStatus,
  projectNames: [],
  projectNameStatus: 'pending' as StateStatus,
  buildKitNames: [],
  buildKitNameStatus: 'pending' as StateStatus,
  cadModelNames: [],
  cadModelNameStatus: 'pending' as StateStatus,
  error: null,
};

export const dropdownDataReducer = createReducer(
  initialState,
  on(loadMaterialFamilyNames, (state) => ({ ...state, materialFamilyStatus: 'loading' as StateStatus })),
  on(loadMaterialFamilyNamesSuccess, (state, { materialFamilyNames }) => ({
    ...state,
    materialFamilyNames: materialFamilyNames,
    error: null,
    materialFamilyStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadMaterialFamilyNamesFailure, (state, { error }) => ({
    ...state,
    error: error,
    materialFamilyStatus: 'error' as StateStatus,
  })),

  on(loadMaterialNames, (state): DropdownDataState => ({ ...state, materialNameStatus: 'loading' as StateStatus })),
  on(loadMaterialNamesSuccess, (state, { materialNames }): DropdownDataState => ({
    ...state,
    materialNames: materialNames,
    error: null,
    materialNameStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadMaterialNamesFailure, (state, { error }): DropdownDataState => ({
    ...state,
    error: error,
    materialNameStatus: 'error' as StateStatus,
  })),
  on(loadOrganizationNames, (state): DropdownDataState => ({ ...state, organizationNameStatus: 'loading' as StateStatus })),
  on(loadOrganizationNamesSuccess, (state, { organizationNames }): DropdownDataState => ({
    ...state,
    organizationNames: organizationNames,
    error: null,
    organizationNameStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadOrganizationNamesFailure, (state, { error }): DropdownDataState => ({
    ...state,
    error: error,
    organizationNameStatus: 'error' as StateStatus,
  })),

  on(loadShapeTypeNames, (state): DropdownDataState => ({ ...state, shapeTypeNameStatus: 'loading' as StateStatus })),
  on(loadShapeTypeNamesSuccess, (state, { shapeTypeNames }): DropdownDataState => ({
    ...state,
    shapeTypeNames: shapeTypeNames,
    error: null,
    shapeTypeNameStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadShapeTypeNamesFailure, (state, { error }): DropdownDataState => ({
    ...state,
    error: error,
    shapeTypeNameStatus: 'error' as StateStatus,
  })),

  on(loadCotsTypeNames, (state): DropdownDataState => ({ ...state, cotsTypeNameStatus: 'loading' as StateStatus })),
  on(loadCotsTypeNamesSuccess, (state, { cotsTypeNames }): DropdownDataState => ({
    ...state,
    cotsTypeNames: cotsTypeNames,
    error: null,
    cotsTypeNameStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadCotsTypeNamesFailure, (state, { error }): DropdownDataState => ({
    ...state,
    error: error,
    cotsTypeNameStatus: 'error' as StateStatus,
  })),

  on(loadProjectNames, (state): DropdownDataState => ({ ...state, projectNameStatus: 'loading' as StateStatus })),
  on(loadProjectNamesSuccess, (state, { projectNames }): DropdownDataState => ({
    ...state,
    projectNames: projectNames,
    error: null,
    projectNameStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadProjectNamesFailure, (state, { error }): DropdownDataState => ({
    ...state,
    error: error,
    projectNameStatus: 'loadError' as StateStatus,
  })),

  on(loadBuildKitNames, (state): DropdownDataState => ({ ...state, buildKitNameStatus: 'loading' as StateStatus })),
  on(loadBuildKitNamesSuccess, (state, { buildKitNames }): DropdownDataState => ({
    ...state,
    buildKitNames: buildKitNames,
    error: null,
    buildKitNameStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadBuildKitNamesFailure, (state, { error }): DropdownDataState => ({
    ...state,
    error: error,
    buildKitNameStatus: 'loadError' as StateStatus,
  })),

  on(loadCadModelNames, (state): DropdownDataState => ({ ...state, cadModelNameStatus: 'loading' as StateStatus })),
  on(loadCadModelNamesSuccess, (state, { cadModelNames }): DropdownDataState => ({
    ...state,
    cadModelNames: cadModelNames,
    error: null,
    cadModelNameStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadCadModelNamesFailure, (state, { error }): DropdownDataState => ({
    ...state,
    error: error,
    cadModelNameStatus: 'loadError' as StateStatus,
  })),
);
